export default function getAcademyProjectDetails(academyProjectData) {
  if (!academyProjectData) return null;

  const {
    id: academyProjectId,
    test_id: academyProjectTestId,
    title: academyProjectTitle,
    meta,
  } = academyProjectData || {};

  const {
    daily_reduction: metaDailyReduction,
    max_reduction: metaMaxReduction,
    offset: metaOffset,
    window: metaWindow,
  } = meta || {};

  return {
    academyProjectId,
    academyProjectTestId,
    academyProjectTitle,
    metaDailyReduction,
    metaMaxReduction,
    metaOffset,
    metaWindow,
  };
}
